import { Button } from "../../components/Button";
import { Dialog } from "../../components/Dialog";

// 「＋ 加一個小工具」(業主 2026-09-17:「清單裡選要顯示哪幾塊、不要的移掉」)。
//
// ==========================================================================
// 為什麼需要它
// ==========================================================================
// 區塊原本是寫死、依角色決定的。工具一多,首頁就變成一面每個人都看不完的牆
// —— 而看不完的東西很快會變成壁紙,連原本有用的那幾塊也一起被忽略。
// 財務只想留錢的、企劃只想留單跟檔期,各自看到自己要的才有用。
//
// ==========================================================================
// 藏起來是一個**旗標**,不是把它從清單裡刪掉
// ==========================================================================
// 刪掉的話,「下一版新加的區塊」與「使用者關掉的區塊」在資料上長得一模一樣
// (兩者都是「存檔裡沒有這一塊」)—— 而新的那一塊本來就該自己出現,
// 關掉的那一塊本來就不該。見 `useHomeLayout.normalize()`。
//
// ==========================================================================
// 每一個都要說得出它是做什麼的
// ==========================================================================
// 只列名字的話,「待我核准」與「代辦事項」看起來是同一件事。

export interface WidgetChoice {
  id: string;
  title: string;
  /** 一句話說它是做什麼的。見檔頭。 */
  hint: string;
  shown: boolean;
}

export interface WidgetPickerProps {
  open: boolean;
  choices: WidgetChoice[];
  onToggle: (id: string, shown: boolean) => void;
  onClose: () => void;
}

export function WidgetPicker({ open, choices, onToggle, onClose }: WidgetPickerProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="首頁小工具"
      footer={
        <div className="flex justify-end">
          <Button variant="primary" onClick={onClose}>
            好了
          </Button>
        </div>
      }
    >
      <p className="m-0 mb-2 text-sm text-[var(--text-2)]">
        勾起來的會出現在首頁。關掉的隨時可以再打開,版面與大小都留著。
      </p>
      <div className="flex flex-col gap-1.5">
        {choices.map((one) => (
          <label
            key={one.id}
            className="flex cursor-pointer items-start gap-2 rounded-[var(--radius)] border border-[var(--border)] px-2.5 py-2"
          >
            <input
              type="checkbox"
              className="mt-1"
              aria-label={one.title}
              checked={one.shown}
              onChange={(event) => onToggle(one.id, event.target.checked)}
            />
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-medium text-[var(--text)]">{one.title}</span>
              <span className="block text-xs text-[var(--text-2)]">{one.hint}</span>
            </span>
          </label>
        ))}
      </div>
    </Dialog>
  );
}
